/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import BillTable from "./components/table";
import ModalContent from "./components/modalContent";
import ModalCommon from "components/Modal";
import Tabs from "./components/tabs";
import Actions from "./components/actions";
export default function Bill01() {
  const { formId, formField } = form;
  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);
  const [list, setList] = React.useState([{ name: "01-2/TTĐB", checked: false }]);
  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        }
      >
        <Box display="flex" flexDirection="column" pb={10} gap={3}>
          <Box textAlign="center">
            <Typography variant="h4" textTransform="uppercase">
              Thông báo phát hành hóa đơn - TB01/AC
            </Typography>
            <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
              (dành cho tổ chức, cá nhân kinh doanh đặt in, tự in)
            </Typography>
          </Box>
          <Formik
            initialValues={initialValues}
            validationSchema={validation}
            onSubmit={handleSubmit}
          >
            {({ values, errors, touched, isSubmitting, setFieldValue }) => (
              <Form id={formId} autoComplete="off">
                <Fields
                  formData={{
                    values,
                    touched,
                    formField,
                    errors,
                  }}
                />

                <BillTable
                  formData={{
                    values,
                    touched,
                    formField,
                    errors,
                  }}
                  setFieldValue={setFieldValue}
                />
                <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                  <SoftButton disabled={isSubmitting} type="submit" variant="gradient" color="dark">
                    {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                  </SoftButton>
                </SoftBox>
              </Form>
            )}
          </Formik>
        </Box>
      </ModalCommon>
    </DashboardLayout>
  );
}

function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { taxId, conpanyName, otherBillType } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={conpanyName.name}
            label={conpanyName.label}
            value={values.conpanyName}
            error={errors.conpanyName && touched.conpanyName}
            success={values.conpanyName?.toString().length > 0 && !errors.conpanyName}
          />
        </Grid>{" "}
      </Grid>
    </Box>
  );
}
